define('bizzabo/views/main/EditAgendaView',[
    'jquery',
    'jquery-ui',
    'jquery-placeholder',
    'backbone',
    'underscore',
    'Handlebars',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/config',
    'jquery-cookie',
    'bizzabo/models/Session',
    'bizzabo/views/main/MainView',
    'bizzabo/views/right/AgendaPreviewView',
    'bizzabo/views/right/EditSessionView',
    'bizzabo/views/popup/ConfirmDialogView',
    'hbars!bizzabo/templates/agendaTop',
    'hbars!bizzabo/templates/editAgendaDay',
    'hbars!bizzabo/templates/trackTitle',
    'hbars!bizzabo/templates/session',
    'hbars!bizzabo/templates/ghostSession'
], function(
    $,
    jQueryUI,
    jQueryPlaceholder,
    Backbone,
    _,
    Handlebars,
    Global,
    BZAPI,
    UTILS,
    Consts,
    CONFIG,
    jqueryCookie,
    Session,
    MainView,
    AgendaPreviewView,
    EditSessionView,
    ConfirmDialogView,
    agendaTopTemplate,
    editAgendaDayTemplate,
    trackTitleTemplate,
    sessionTemplate,
    ghostSessionTemplate
    ) {

    var agendaLayout = {
        rowHeight: 20,
        rowsPerHour: 12
    };

    var EditAgendaView = MainView.extend({

        tabClass : Consts.UI.tabClasses.AGENDA,
        hasDetails : true,

        prepare : function() {
            this.listenTo(Backbone, 'track_change', this.reCalcScreen);
            var thisEvent = Global.modelPool.getEvent(this.model.get("eventId"));
            this.prepareModels([thisEvent, this.options.servicePlan, this.model]);
        },

        reCalcScreen: function() {
            var agendaScreenSize = this.calcScreeSize();
            this.$('#editAgenda').removeClass('agenda-10 agenda-15 agenda-20 agenda-25 agenda-30');
            agendaScreenSize && this.$('#editAgenda').addClass(agendaScreenSize);
        },

        calcScreeSize: function() {
            var max = this.model.getMaxTracks();
            if(max <= 10) {
                return;
            }
            else if (max <= 15) {
                return 'agenda-15';
            }
            else if (max <= 20) {
                return 'agenda-20';
            }
            else if(max <= 25) {
                return 'agenda-25';
            }
            else if(max <= 30) {
                return 'agenda-30';
            }
        },

        render : function() {

            $('section.main').addClass('main-agenda-specific');

            this.renderMainView({
                hasDetails : true,
                wantsFullWidth : true,
                isAgenda: true
            });
            var contentView = new EditAgendaContentView({
                model : this.model,
                deepLinkParams : this.options.deepLinkParams
            });
            contentView.mainView = this;
            this.putContentView(contentView);
            this.openDetails();
            this.reCalcScreen();
            this.$('.main-content-agenda-specific').scroll(function() {
                contentView.scrollListener(contentView, this);
            });
            return this;
        },

        applyDeepLink: function(deepLinkParams) {
            if (this.contentView) {
                this.contentView.options.deepLinkParams = deepLinkParams;
                Backbone.trigger(Consts.Notifications.mainPage.SWITCHED);
            }
        },

        remove : function() {
            this.removeMainView();
            this.$('.main-content-agenda-specific').unbind('scroll');
        }
    });

    var EditAgendaContentView = Backbone.View.extend({

        events : {
            "mousedown .gridTable td[class*='track']" : "formGridTrackCellMouseDown",
            "mouseenter .gridTable td[class*='track']" : "formGridTrackCellMouseEnter"
        },

        id : "editAgenda",
        tagName : "section",
        letMeRemoveIntro : true, // override
        hours : ['12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm'],
        startAutoComplete : ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00',
            '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30',
            '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30'],

        pixelsPerHour : 0,
        pixelsPerDay : 0,
        currentDay : 0,
        previousDay : undefined,
        dayAnimationLock : false,
        setDayDisplayQueue : [],
        previewView : undefined,
        dayChangeOffsetInPixels : 100, // depends on style.css: .currentDay .trackTitles
        tdDragStart : undefined,
        dragStartTimeout : undefined,
        clickDuration : 0, // set to 300 millis to enable different behaviour for click and for drag
        rowsPerHourRange : [],
        dayViews : [],

        initialize : function() {
            _.bindAll(this, "formGridTrackCellMouseUp");
            this.model.isBeingEdited = true;
            this.scrollOffsetFromTop = agendaLayout.rowHeight * agendaLayout.rowsPerHour * 2;
            this.listenTo(this.model, 'change:eventId', this.modelEventIdChange);
            this.listenTo(Global.modelPool.getEvent(this.model.get('eventId')), 'change:event-is-active', this.activeStatusChanged);

            this.listenTo(this.model, 'imported', this.render);
            this.listenTo(Backbone, Consts.Notifications.mainPage.AGENDA_PAGE_LOADED, this.onPageLoad);
            this.listenTo(Backbone, Consts.Notifications.agenda.SCROLL_TO_NEXT_DAY, this.formNextDayClick);
            this.listenTo(Backbone, Consts.Notifications.agenda.SCROLL_TO_PREV_DAY, this.formPrevDayClick);
            this.listenTo(this.model.get('day'), 'add remove reset', _.debounce(this.render, 300));
            this.listenTo(Backbone, 'track_change', this.scrollTrackTitle);

            var thisView = this;
            $(window).scroll(function() {
                thisView.scrollListener(thisView);
            });
            this.hours = this.generateHoursArray();
        },

        remove : function() {
            this.model.isBeingEdited = false;
            this.model.wasEdited = true;

            $(window).unbind('scroll');

            this.mainView.removeRightPanelView();
            if (this.previewView) {
                this.previewView.remove();
                this.previewView = undefined;
            }
            this.removeDayViews();
            this.removeGhostSessionView();
            $("header .agendaTop").remove();
            $("header div.topContent h1").show();
            $("header div.topContent .top-panel-event-website-link").show();
            return Backbone.View.prototype.remove.call(this);
        },

        render : function(cb) {
            this.renderTop();
            this.removeDayViews();
            _.each(this.model.get("day").models, function(day) {
                this.addDayView(day);
            }, this);
            this.dayViews.sort(function(a, b) {
                return a.model.get("index") - b.model.get("index");
            });

            this.setDayDisplay(this.currentDay, false);
            this.findAndMarkEditedSessionOnGrid();
            this.activeStatusChanged();
            if (_.isFunction(cb)) {
                cb();
            }
            return this;
        },

        activeStatusChanged : function() {
            if (Global.modelPool.getEvent(this.model.get('eventId')).get('event-is-active')) {
                this.$('input').attr('disabled', 'disabled');
                this.$('.addTrack, .btnEffect').toggleClass('hide', true);
                var overlay =  $('<div>').addClass('agenda-overlay');
                this.$('.sessionsWidthContainer').append(overlay);

            } else {
                this.$('input').removeAttr('disabled', 'disabled');
                this.$('.addTrack, .btnEffect').toggleClass('hide', false);
                this.$('.agenda-overlay').remove();
            }
        } ,

        removeDayViews : function() {
            this.dayViews = UTILS.removeAllSubViewsInArray(this.dayViews);
        },

        addDayView : function(day) {
            var newDayView = new DayView({
                model : day,
                editAgendaView : this,
                attributes : {
                    class : "day" + day.get("index")
                }
            });
            this.dayViews.push(newDayView);
            newDayView.render();
            this.$el.append(newDayView.$el);
        },

        applyDeepLink: function(deepLinkParams) {
            var removeIntroView = function() {
                Global.appView.introView.remove();
            };

            if (deepLinkParams && deepLinkParams.cid) {
                var dayViewOfSession = _.find(this.dayViews, function(day){
                    return day.sessionViews && day.sessionViews[deepLinkParams.cid];
                });
                var thisView = this;
                var sessionView = dayViewOfSession && dayViewOfSession.sessionViews[deepLinkParams.cid];
                this.setDayDisplay(this.currentDay, false, function() {
                    dayViewOfSession && sessionView && dayViewOfSession.editSession(sessionView, deepLinkParams);
                    sessionView && thisView.scrollToSessionViewOrDay(sessionView, undefined, removeIntroView);
                });
            } else {
                this.setDayDisplay(this.currentDay, true, removeIntroView);
                this.renderAgendaPreview();
            }

            if (deepLinkParams.errors) {
                this.previewView && this.previewView.switchToTab('agenda-errors');
            }
        },

        onPageLoad : function() {
            var deepLinkParams = this.options.deepLinkParams;
            delete this.options.deepLinkParams;
            this.applyDeepLink(deepLinkParams);

            this.addGhostSessionView();
        },

        scrollTrackTitle: _.debounce(function() {
            $('.currentDay .trackTitles').css('top', $(window).scrollTop() - $('.currentDay .sessionsWidthContainer').offset().top + 100);
        }, 100),

        scrollListener : function(context, el) {
            var currentPosition = $(el).scrollTop();
            var currentDay = Math.floor((currentPosition + context.dayChangeOffsetInPixels) / context.pixelsPerDay);
            if ((context.previousDay === currentDay)) {
                this.scrollTrackTitle();
                return;
            }
            $('.currentDay .trackTitles').removeAttr('style');
            context.previousDay = currentDay;
            context.$(".trackTitles").removeClass("transition"); // to prevent the weird animation when changing position absolute to fixed
            context.setDayDisplay(currentDay, false);
            context.$(".trackTitles").addClass("transition"); // to prevent the weird animation when changing position absolute to fixed

        },

        renderAgendaPreview : function() {
            this.previewView && this.previewView.remove();
            var thisEvent = Global.modelPool.getEvent(this.model.get("eventId"));
            this.previewView = new AgendaPreviewView({
                model : thisEvent,
                agenda : this.model
            });

            this.mainView.putRightPanelView(this.previewView);
        },

        renderTop : function() {
            $("header .agendaTop").remove();
            var thisEvent = Global.modelPool.getEvent(this.model.get("eventId"));
            var html = agendaTopTemplate(thisEvent);
            $.cookie(CONFIG.PREVIEW_COOKIE_NAME, true, {
                secure: true,
                domain: 'bizzabo.com',
                path: '/'
            });
            $("header div.topContent h1").hide();
            $("header div.topContent .top-panel-event-website-link").hide();
            $("header div.topContent .top-panel-event-website-link").after(html);
            $("header div.topContent .previewButtonTop").removeClass('hide');
        },

        formNextDayClick : function() {
            var showDayNumber = this.currentDay + 1;
            if (showDayNumber < this.model.get("day").length) {
                this.scrollToSessionViewOrDay(showDayNumber);
            }
        },

        formPrevDayClick : function() {
            var showDayNumber = this.currentDay - 1;
            if (showDayNumber >= 0) {
                this.scrollToSessionViewOrDay(showDayNumber);
            }
        },

        setDayDisplay : function(dayIndex, isScroll, cb) {
            // validate
            var numberOfDays = this.model.get('day').length;
            if (dayIndex < 0 || dayIndex >= numberOfDays) {
                return;
            }
            // Buffer calls to this function
            if (this.dayAnimationLock) {
                this.setDayDisplayQueue.push({
                    dayIndex : dayIndex,
                    isScroll : isScroll,
                    cb : cb
                });
                return;
            }
            this.dayAnimationLock = true;

            // before changing the value
            var dayView = this.dayViews[this.currentDay];
            dayView && dayView.toggleCurrentDayClass(false);
            $("header .agendaTop .day" + this.currentDay).removeClass("currentDay");

            // after value change
            this.currentDay = dayIndex;
            dayView = this.dayViews[this.currentDay];
            dayView && dayView.toggleCurrentDayClass(true);
            $("header .agendaTop .day" + this.currentDay).addClass("currentDay");

            var noMoreNext = this.currentDay >= numberOfDays - 1;
            var noMorePrev = this.currentDay <= 0;
            var nextBtnElement = $("header a[name='nextDay']");
            var prevBtnElement = $("header a[name='prevDay']");

            var thisView = this;
            var newTop = -20 * this.currentDay;
            $("header .agendaTop ul").animate({
                top : newTop + "px"
            }, 'fast', 'easeOutCubic', function() {
                prevBtnElement.toggleClass("inactiveBtn", noMorePrev);
                nextBtnElement.toggleClass("inactiveBtn", noMoreNext);
                thisView.dayAnimationLock = false;
                if (isScroll) {
                    thisView.scrollToSessionViewOrDay(thisView.currentDay, thisView, cb);
                } else if (cb) {
                    cb();
                }
                if (thisView.setDayDisplayQueue.length > 0) {
                    var queuedCall = thisView.setDayDisplayQueue[0];
                    thisView.setDayDisplayQueue.shift();
                    thisView.setDayDisplay(queuedCall.dayIndex, queuedCall.isScroll, queuedCall.cb);
                }
            });
        },

        modelEventIdChange : function() {
            Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, '/event/' + this.model.get('eventId') + '/agenda', {
                trigger : false
            });
        },

        isEditingSession : function() {
            return this.mainView.rightPanelView && (this.mainView.rightPanelView != this.previewView);
        },

        unFocusSession : function() {
            if (this.isEditingSession()) {
                this.mainView.rightPanelView.sessionView.$el.removeClass("editedSession");
                this.mainView.removeRightPanelView();
            }
        },

        unFocusSessionAndShowPreview : function() {
            this.unFocusSession();
            this.renderAgendaPreview();
        },

        findAndMarkEditedSessionOnGrid : function() {
            if (this.isEditingSession()) {
                var cid = this.mainView.rightPanelView.model.cid;
                var days = this.model.get("day");
                for (var i = 0; i < days.length; i++) {
                    var day = days.at(i);
                    var daySessions = day.get("session");
                    if (daySessions.get(cid) !== undefined) {
                        var dayIndex = day.get("index");
                        var dayView = this.dayViews[dayIndex];
                        var sessionView = dayView.sessionViews[cid];
                        dayView.markEditedSessionOnGrid(sessionView);
                        break;
                    }
                }
            }
        },

        getParamsFromClass : function(element) {
            var classes = element.className.split(" ");
            var res = {};
            for (var classIndex in classes) {
                var classString = classes[classIndex];
                this.findParam(res, classString, "day")
                    || this.findParam(res, classString, "track")
                    || this.findParam(res, classString, "hour")
                    || this.findParam(res, classString, "row")
                    || this.findParam(res, classString, "rightCol")
                || this.findParam(res, classString, "leftCol");
            }
            return res;
        },

        findParam : function(resObj, classString, param) {
            if (classString.indexOf(param) > -1) {
                resObj[param] = (classString == param) ? true : parseInt(classString.substr(param.length));
                return true;
            }
            return false;
        },

        scrollToSessionViewOrDay : function(sessionViewOrDay, context, cb) {
            if (_.isUndefined(context)) {
                context = this;
            }
            if (_.isUndefined(sessionViewOrDay)) {
                sessionViewOrDay = context.currentDay;
            }

            var destination = 0;
            if (_.isNumber(sessionViewOrDay)) {
                var day = context.model.get("day").at(sessionViewOrDay);
                var dayView = this.dayViews[sessionViewOrDay];
                if (day.get("session").length > 0) {
                    var firstSession = day.getExtremeSession(true);
                    sessionViewOrDay = dayView.sessionViews[firstSession.cid];
                } else {
                    destination = UTILS.getViewOffsetFromTop(dayView) + dayView.getOffsetFromDayTop(Consts.UI.agenda.DEFAULT_HOUR);
                }
            }
            if (_.isObject(sessionViewOrDay)) {
                destination = UTILS.getViewOffsetFromTop(sessionViewOrDay)
            }

            var scrollTop = $(".main-content-agenda-specific").scrollTop() + 90;
            $(".main-content-agenda-specific").animate({
                scrollTop : destination - context.scrollOffsetFromTop + scrollTop
            }, 500, 'easeInOutExpo', cb);
        },

        generateHoursArray : function() {
            this.pixelsPerHour = agendaLayout.rowHeight * agendaLayout.rowsPerHour;
            this.pixelsPerDay = this.pixelsPerHour * 24;
            this.rowsPerHourRange = _.range(1, agendaLayout.rowsPerHour);

            var newHours = [];
            for (var hourIndex = 0; hourIndex < 24; hourIndex++) {
                var hour = {
                    amPm : this.hours[hourIndex],
                    rows : this.rowsPerHourRange,
                    hourIndex : hourIndex
                };
                newHours.push(hour);
            }
            return newHours;
        },

        /* drag to create a new session */

        formGridTrackCellMouseDown : function(eventObject) {
            var params = this.getParamsFromClass(eventObject.target);
            if (_.isNaN(params.hour)) {
                return;
            }

            // Blur the currently focused element, because drag doesn't do it
            if (document.activeElement != document.body) {
                $(document.activeElement).blur();
            }

            var currentMillis = new Date().getTime();
            var dayTds = this.$("td.day" + params.day).filter(".data");
            var cellsInCol = 24 * agendaLayout.rowsPerHour;
            var tracksNum = dayTds.length / cellsInCol;
            var startIndex = _.indexOf(dayTds, eventObject.target);
            var startRow = this.getRowFromIndex(startIndex, tracksNum);
            this.tdDragStart = _.extend({
                millis : currentMillis,
                eventObj : eventObject.target,
                dayTds : dayTds,
                numberOfTracks : tracksNum,
                startRow : startRow
            }, params);
            this.$(this.tdDragStart.eventObj).addClass("active");

            var thisView = this;
            this.dragStartTimeout = setTimeout(function() {
                if (thisView.tdDragStart) {
                    thisView.$(thisView.tdDragStart.eventObj).addClass("onDrag").removeClass("active");
                }
            }, thisView.clickDuration);

            eventObject.preventDefault(); // to prevent text selection during drag
            $("body").on("mouseup", this.formGridTrackCellMouseUp); // to deal with a 'mouseup' event outside this.$el
        },

        formGridTrackCellMouseEnter : function(eventObject) {
            if (this.tdDragStart) {
                var start = this.tdDragStart;
                var params = this.getParamsFromClass(eventObject.target);
                if ((!_.isNaN(params.hour)) && start.day === params.day) {
                    start.prevDayTds && start.prevDayTds.removeClass("onDrag");

                    var thisView = this;
                    var currentIndex = _.indexOf(start.dayTds, eventObject.target);
                    var currentRow = thisView.getRowFromIndex(currentIndex, start.numberOfTracks);
                    start.prevDayTds = start.dayTds.filter(
                        function(index) {
                            var indexCol = index % start.numberOfTracks;
                            var indexRow = thisView.getRowFromIndex(index, start.numberOfTracks);
                            return ((indexCol - start.track) * (indexCol - params.track) < 1) &&
                                ((indexRow - currentRow) * (indexRow - start.startRow) < 1)
                        }).addClass("onDrag");
                }
            }
        },

        getRowFromIndex : function(index, inc) {
            return Math.ceil((index + 1) / inc) - 1;
        },

        formGridTrackCellMouseUp : function(eventObject) {
            var currentMillis = new Date().getTime();
            var thisView = this;
            if (thisView.dragStartTimeout) {
                clearTimeout(thisView.dragStartTimeout);
                thisView.dragStartTimeout = undefined;
            }

            $("body").off("mouseup", thisView.formGridTrackCellMouseUp);
            if (_.isUndefined(thisView.tdDragStart)) { // mouse was released outside the window
                thisView.$("td").removeClass("onDrag");
                return;
            }
            thisView.$(thisView.tdDragStart.eventObj).removeClass("active onDrag");

            var isClick = thisView.tdDragStart.eventObj === eventObject.target ? currentMillis - thisView.tdDragStart.millis < thisView.clickDuration : false;
            if (isClick) { // mouse was clicked: un-focus
                thisView.$("td").removeClass("onDrag");
                thisView.tdDragStart = undefined;
                thisView.unFocusSessionAndShowPreview();
                Backbone.trigger(Consts.Notifications.agenda.GRID_CLICK);
                return;
            }

            thisView.tdDragStart.prevDayTds && thisView.tdDragStart.prevDayTds.removeClass("onDrag");
            if (!thisView.$(eventObject.target).hasClass("data")) {  // mouse was released on an irrelevant element
                thisView.tdDragStart = undefined;
                return;
            }

            var params = thisView.getParamsFromClass(eventObject.target);
            var isFlipped = thisView.tdDragStart.hour === params.hour ? thisView.tdDragStart.row > params.row : thisView.tdDragStart.hour > params.hour;
            var gridDragStartTime = thisView.getTimeFromHourAndRow(thisView.tdDragStart.hour, thisView.tdDragStart.row + (isFlipped ? 1 : 0));
            var gridDragEndTime = thisView.getTimeFromHourAndRow(params.hour, params.row + (isFlipped ? 0 : 1));
            if (gridDragEndTime === "24:00") {
                gridDragEndTime = "23:59";
            }
            var trackIndexes = params.track === thisView.tdDragStart.track ? [params.track] : _.range(Math.min(params.track, thisView.tdDragStart.track), Math.max(params.track, thisView.tdDragStart.track) + 1);
            var dayView = thisView.dayViews[params.day];
            dayView.addAndEditNewSession(trackIndexes, isFlipped ? gridDragEndTime : gridDragStartTime, isFlipped ? gridDragStartTime : gridDragEndTime);
            thisView.tdDragStart = undefined;
        },

        getTimeFromHourAndRow : function(hour, row) {
            var rowMinutes = Math.round(row * 60 / agendaLayout.rowsPerHour);
            if (rowMinutes === 60) {
                rowMinutes = 0;
                hour++;
            }
            var hourString = hour < 10 ? "0" : "";
            var rowsString = rowMinutes < 10 ? "0" + rowMinutes : rowMinutes;
            return hourString + hour + ":" + rowsString;
        },

        /* Ghost session */

        addGhostSessionView : function() {
            if (_.any(this.model.get("day").models, function(day) {
                return day.get("session").length > 0 || day.get("track").length > 1;
            })) {
                return;
            }

            var session = new Session();
            session.isGhost = true;
            this.ghostSessionView = new GhostSessionView({
                model : session,
                attributes : {
                    "class" : "ghostSession",
                    "title" : "Add session"
                },
                editAgendaView : this,
                dayView : this.dayViews[0]
            });
            this.ghostSessionView.render();
            this.dayViews[0].$(".sessions").append(this.ghostSessionView.el);
        },

        removeGhostSessionView : function() {
            if (this.ghostSessionView) {
                this.ghostSessionView.remove();
                this.ghostSessionView = undefined;
            }
        },

        moveSessionBetweenDays : function(fromDay, toDay, session) {
            var sessionTracksArr = fromDay.getTracksForSession(session);
            var tempCollection = new Backbone.Collection(sessionTracksArr);
            var sessionTrackIndexes = tempCollection.pluck("index");
            var minTrackIndex = Math.min.apply(Math, sessionTrackIndexes);
            var numberOfTracks = sessionTrackIndexes.length;
            var numberOfTracksInToDay = toDay.get("track").length;
            var rangeEnd = Math.min(numberOfTracksInToDay, numberOfTracks);
            var newTrackIndexes = _.range(minTrackIndex, rangeEnd);
            fromDay.removeSession(session);
            toDay.addNewSession(session, newTrackIndexes);
            var toDayView = this.dayViews[toDay.get("index")];
            return toDayView.addSessionView(session);
        }
    });

    var DayView = Backbone.View.extend({

        events : {
            "click .addTrack" : "formAddTrack"
        },

        sessionViews : undefined,
        trackTitleViews : undefined,
        editAgendaView : undefined,

        initialize : function() {
            this.sessionViews = {};
            this.trackTitleViews = {};
            this.editAgendaView = this.options.editAgendaView;
            this.listenTo(this.model.get("session"), "change:end", this.checkCollisions);
            this.listenTo(this.model.get("session"), "remove", this.removeSessionView);
            this.listenTo(this.model.get("relation-session-track"), "add remove", this.checkCollisions);
            this.listenTo(this.model.get("track"), "add remove", this.render);
        },

        remove : function() {
            this.removeTrackTitleViews();
            this.removeSessionViews();
            this.stopListening();
            this.$el.remove();
            return this;
        },

        render : function(cb) {
            this.removeTrackTitleViews();
            this.removeSessionViews();

            var gridData = this.generateGridData();
            var html = editAgendaDayTemplate(_.extend(this.model, gridData));
            this.$el.html(html);
            this.setTrackWidths();

            _.each(this.model.get("track").models, function(track) {
                this.addTrackTitleView(track);
            }, this);

            _.each(this.model.get("session").models, function(session) {
                this.addSessionView(session);
            }, this);

            this.$(".gridTable tr").css("height", agendaLayout.rowHeight + "px");
            this.editAgendaView.findAndMarkEditedSessionOnGrid();
            this.toggleCurrentDayClass(this.model.get("index") === this.editAgendaView.currentDay);

            if (_.isFunction(cb)) {
                cb();
            }
            return this;
        },

        toggleCurrentDayClass : function(isCurrentDay) {
            this.$el.toggleClass("currentDay", isCurrentDay);
        },

        generateGridData : function() {
            var numberOfTracks = this.model.get("track").length;
            var thisIndex = this.model.get("index");
            return {
                hours : this.editAgendaView.hours,
                firstDay : thisIndex === 0,
                allowAddingTracks : numberOfTracks < Consts.UI.agenda.MAX_NUM_OF_TRACKS
            };
        },

        checkCollisions : function() {
            this.model.validateSessionCollisions();
        },

        editSession : function(sessionView, deepLinkParams, doNotOpenDetailsPanel) {
            var sessionIsAlreadyBeingEdited = this.editAgendaView.isEditingSession() && (this.editAgendaView.mainView.rightPanelView.sessionView.model == sessionView.model);
            if (sessionIsAlreadyBeingEdited) {
                sessionView.$el.addClass("editedSession");
                !doNotOpenDetailsPanel && this.editAgendaView.mainView.openDetails();
                this.editAgendaView.mainView.rightPanelView.switchToTab('session');
                return;
            }

            this.editAgendaView.unFocusSession();
            this.editAgendaView.mainView.removeRightPanelView();
            var newEditSessionView = new EditSessionView({
                model : sessionView.model,
                dayView : this,
                editAgendaView : this.editAgendaView,
                attributes : {
                    "class" : "editSessionDetails"
                },
                deepLinkParams : deepLinkParams
            });
            this.editAgendaView.mainView.putRightPanelView(newEditSessionView);
            !doNotOpenDetailsPanel && this.editAgendaView.mainView.openDetails();
            this.markEditedSessionOnGrid(sessionView);
        },

        markEditedSessionOnGrid : function(sessionView) {
            this.editAgendaView.mainView.rightPanelView.sessionView = sessionView;
            sessionView.$el.addClass("editedSession");
        },

        removeSessionViews : function() {
            this.sessionViews = UTILS.removeAllSubViewsInMap(this.sessionViews);
        },

        removeTrackTitleViews : function() {
            this.trackTitleViews = UTILS.removeAllSubViewsInMap(this.trackTitleViews);
        },

        addAndEditNewSession : function(trackIndexes, startTime, endTime) {
            if (_.isUndefined(trackIndexes)) {
                trackIndexes = [0];
            }
            if (_.isUndefined(startTime)) {
                startTime = Consts.UI.agenda.DEFAULT_HOUR;
            }
            var newSession = this.model.addNewSession({
                start : startTime,
                end : endTime
            }, trackIndexes);
            var newSessionView = this.addSessionView(newSession);
            this.editSession(newSessionView);
            this.checkCollisions();
        },

        getOffsetFromDayTop : function(start) {
            var parts = start.split(":");
            var hourString = parts[0];
            var hourIndex = parseInt(hourString, 10);
            var hourInPixels = this.editAgendaView.pixelsPerHour * hourIndex;

            var minutesString = parts[1];
            var minutes = parseInt(minutesString, 10);
            var offsetInPixels = Math.round(minutes / 60 * this.editAgendaView.pixelsPerHour);
            return hourInPixels + offsetInPixels;
        },

        setTrackWidths : function() {
            var trackWidth = this.getTrackWidth();
            this.$("table td[class*='track']").css("width", trackWidth + "%");
        },

        getTrackWidth : function() {
            return 100 / this.model.get("track").length;
        },

        getTrackLeft : function(trackIndex) {
            var numberOfTracks = this.model.get("track").length;
            return trackIndex / numberOfTracks * 100;
        },

        addSessionView : function(session) {
            this.editAgendaView.removeGhostSessionView();
            var sessionView = new SessionView({
                model : session,
                attributes : {
                    "title" : "Edit session"
                },
                dayView : this
            });
            this.sessionViews[session.cid] = sessionView;
            sessionView.render();
            this.$(".sessions").append(sessionView.el);
            return sessionView;
        },

        removeSessionView : function(session) {
            // remove session-speaker relations. here because Session doesn't know Agenda
            this.editAgendaView.model.get("relation-session-speaker").removeAllRelations(session);

            var sessionView = this.sessionViews[session.cid];
            this.sessionViews[session.cid] = undefined;
            sessionView.remove();
        },

        addTrackTitleView : function(track) {
            var trackTitleView = new TrackTitleView({
                model : track,
                attributes : {
                    class : "trackTitle"
                },
                editAgendaView : this.editAgendaView,
                dayView : this
            });
            this.trackTitleViews[trackTitleView.cid] = trackTitleView;
            trackTitleView.render();
            this.$(".trackTitles").append(trackTitleView.el);
            this.$('input[placeholder], textarea[placeholder]').placeholder(); // for IE
            return trackTitleView;
        },

        formAddTrack : function() {
            this.model.addNewTrack();
            Backbone.trigger('track_change');
        }
    });

    var TrackTitleView = Backbone.View.extend({

        events : {
            "click a[name='removeTrack']" : "formRemoveTrack",
            "keyup input[name='track']" : "formRenameTrack" // keyup for the enter key
        },

        tagName : "nav",
        dayView : undefined,

        initialize : function() {
            this.dayView = this.options.dayView;
            this.listenTo(this.model, "change:name", this.modelTrackNameChange);
            this.listenTo(this.model, "destroy", this.remove);
        },

        render : function() {
            var isSingleTrack = this.dayView.model.get("track").length === 1;
            if (!this.model.get('name')) {
                this.model.set('name', 'Track ' + (this.model.get('index') + 1));
            }
            var html = trackTitleTemplate(_.extend(this.model, {
                isSingleTrack : isSingleTrack
            }));
            this.$el.html(html);
            this.$el.css({
                left : this.dayView.getTrackLeft(this.model.get("index")) + "%",
                width : this.dayView.getTrackWidth() * Consts.UI.agenda.TRACK_TITLES_WIDTH_DIFF + "%"
            });
            return this;
        },

        formRenameTrack : function(eventObject) {
            var code = (eventObject.keyCode ? eventObject.keyCode : eventObject.which);
            if (code == 13) { // Enter key code
                eventObject.target.blur();
                return;
            }

            var newName = this.$('input[name="track"]').val();
            this.model.set({
                'name' : newName
            });
            this.model.wasChangedFromForm = true; // todo remove when editAgendaView have mixins
            this.model.isSynced = false;
        },

        formRemoveTrack : function() {
            var day = this.dayView.model;
            var trackToRemove = this.model;
            var actionFunction = function() {
                day.removeTrack(trackToRemove);
                Backbone.trigger('track_change');
            };

            if (this.dayView.model.get("relation-session-track").hasOneToOnes(trackToRemove)) {
                new ConfirmDialogView({
                    title : 'Unsaved work',
                    text : 'All current track sessions will be deleted, are you sure you want to delete the track?',
                    confirm : 'Delete',
                    cancel : 'Cancel',
                    onConfirm : actionFunction,
                    isDestructive : true
                }).show();
                return;
            }
            actionFunction();
        },

        modelTrackNameChange : function() {
            this.$('input[name="track"]').val(this.model.get("name"));
        }
    });

    var SessionView = Backbone.View.extend({

        events : {
            "click" : "formSessionClick"
        },

        tagName : "article",
        isValid : true,
        dayView : undefined,

        initialize : function() {
            this.dayView = this.options.dayView;
            this.listenTo(this.model, "change trackRelation:add trackRelation:remove", this.modelSessionChange);
            this.listenTo(this.model, "validated", this.toggleValidation);
            if (!this.model.isBrandNew()) {
                this.model.validate();
            }
        },

        remove: function() {
            this.draggable && this.$el.draggable('destroy');
            return Backbone.View.prototype.remove.call(this);
        },

        makeDraggable: function() {
            if (this.draggable) {
                return;
            }

            var thisView = this;
            var session = this.model;
            var element = this.$el;
            _.defer(function() {
                var containment = element.parent('.sessionsWidthContainer');
                var day = thisView.dayView.model;
                var tracks = day.get('track').length;
                var trackWidth = Math.ceil(containment.width() / tracks);
                element.draggable({
                    axis: 'xy',
                    distance: 5,
                    opacity: 0.85,
                    zIndex: 100,
                    containment: containment,
                    start: function(event, ui) {
                        trackWidth = Math.ceil(containment.width() / tracks);
                        thisView.dayView.editSession(thisView, null, true);
                    },
                    drag: function(event, ui) {
                        var topWithGrid = Math.round(ui.position.top / agendaLayout.rowHeight) * agendaLayout.rowHeight;
                        var minutes = topWithGrid / agendaLayout.rowHeight * (60 / agendaLayout.rowsPerHour);
                        if (minutes != thisView.prevMinutes) {
                            var endsAtMidnight = (minutes + thisView.model.get('duration') == 1440);
                            var minutesText = UTILS.minutesToTimeString(minutes);
                            var duration = (endsAtMidnight ? (thisView.model.get('duration') - 1) : undefined);
                            session.setTime({
                                start: minutesText,
                                duration: duration
                            }, true, true);
                            thisView.prevMinutes = minutes;
                        }
                    },
                    stop: function(event, ui) {
                        element.css('z-index', '');
                        var firstTrack = Math.round(ui.position.left / trackWidth);
                        var oldTracks = day.getTracksForSession(session);
                        day.setSessionToTracks(session, firstTrack, firstTrack + oldTracks.length);
                    }
                });
                element.mousedown(function() {
                    if (document.activeElement.nodeName.toLowerCase() !== 'body') {
                        document.activeElement.blur();
                    }
                });
                thisView.draggable = true;
            });
        },

        render : function() {
            var html = sessionTemplate(this.model);
            this.adjustPosition();
            this.$el.html(html);
            this.toggleValidation();
            if (!Global.modelPool.getEvent(this.model.get("eventId")).get('event-is-active')) {
                this.makeDraggable();
            }
            return this;
        },

        adjustPosition : function() {
            this.$el.css({
                top : this.calculateSessionTop(),
                left : this.calculateSessionLeft(),
                width : this.calculateSessionWidth(),
                height : this.calculateSessionHeight()
            });
        },

        renderTime : function() {
            var html = Handlebars.helpers.timeFormatFrom24Hour(this.model.get('start')) + ' - ' + Handlebars.helpers.timeFormatFrom24Hour(this.model.get('end'));
            this.$('.gridSessionTime').html(html);
        },

        formSessionClick : function() {
            this.dayView.editSession(this);
        },

        modelSessionChange : function() {
            if (this.model.isValid(true)) {
                this.render();
            } else if (this.model.isValid(['start', 'end', 'duration'])) {
                this.renderTime();
                this.adjustPosition();
            }
        },

        toggleValidation : function() {
            var shouldValidate = (this.model.wasEdited || this.model.isSynced);
            var isValid = shouldValidate ? this.model.isValid() : true;
            if (isValid != this.isValid) {
                this.$el.toggleClass('invalidSession', !isValid);
                this.isValid = isValid;
            }
        },

        // Calculate location on grid

        getSessionTrackIndexes : function() {
            var tracks = this.dayView.model.getTracksForSession(this.model);
            var collection = new Backbone.Collection(tracks);
            return collection.pluck("index");
        },

        calculateSessionTop : function() {
            return this.dayView.getOffsetFromDayTop(this.model.get("start")) + "px";
        },

        calculateSessionHeight : function() {
            var durationString = this.model.get("duration");
            var duration = parseInt(durationString, 10);
            var pixelsPerMinute = this.dayView.editAgendaView.pixelsPerHour / 60;
            var borderPixels = 2;
            var res = Math.round(pixelsPerMinute * duration) - (borderPixels * 2);
            return res + "px";
        },

        calculateSessionLeft : function() {
            var minTrack = Math.min.apply(Math, this.getSessionTrackIndexes());
            var trackLeft = this.dayView.getTrackLeft(minTrack);
            return trackLeft + "%";
        },

        calculateSessionWidth : function() {
            var minTrack = Math.min.apply(Math, this.getSessionTrackIndexes());
            var maxTrack = Math.max.apply(Math, this.getSessionTrackIndexes());
            var diff = maxTrack - minTrack + 1;
            var singleTrackWidth = this.dayView.getTrackWidth();
            var widthPercent = singleTrackWidth * diff;
            return widthPercent + "%";
        }
    });

    var GhostSessionView = SessionView.extend({

        initialize : function() {
            this.dayView = this.options.dayView;
            GhostSessionView.__super__.initialize.apply(this, arguments);
            this.listenTo(Backbone, Consts.Notifications.agenda.GRID_CLICK, this.onGridClick);
        },

        render : function() {
            var html = ghostSessionTemplate({});
            this.adjustPosition();
            this.$el.html(html);
            return this;
        },

        onGridClick : function() {
            this.shake();
        },

        shake : function() {
            this.$el.effect("shake", {
                distance : 5
            }, 100);
        },

        /*
         @override
         */
        getSessionTrackIndexes : function() {
            return [0];
        },

        /*
         @override for IE
         */
        formSessionClick : function() {
            this.shake();
        }
    });

    return EditAgendaView;

});
